import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DatePicker from 'react-date-picker';

import compose from 'recompose/compose';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

// import LockOutline from "@material-ui/icons/LockOutline";
import Check from '@material-ui/icons/Check';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import CreateCaseForm from 'components/Forms/CreateCaseForm';
import Card from 'components/Card/Card.jsx';
import Transition from 'components/Transition';
import { startUpdateUser } from 'store/actions/userActions';
import { capitalize } from '../../util';
import config from 'config';
import Style from 'assets/jss/material-dashboard-pro-react/views/setupStyle';

import { push } from 'connected-react-router';

class SetupPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      advertiser: false,
      email: this.props.email || 'no email',
      continueForm: false,
      setup: true,
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
      email: this.props.email,
    });
  };

  handleSelectChange = (e) => {
    this.setState({
      userType: e.target.value,
    });
  };

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { history, uid, startUpdateUser, push } = this.props;
    startUpdateUser(uid, this.state).then(()=>push(this.state.userType == 'client' ? '/create-case' : '/create-firm'));
  };

  handleDateChange = (dob) => {
    if (dob) {
      this.setState(() => ({ dob }));
    }
  };

  handleToggle = (value) => {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked,
    });
  };

  isAdvertiser = () => {
    this.setState({
      advertiser: !this.state.advertiser,
    });
  };

  continueForm = () => {
    this.setState({
      continueForm: true,
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        {!this.state.continueForm && (
          <GridContainer justify="left" style={{ marginTop: '20vh', marginLeft: '1%' }}>
            <GridItem xs={12} sm={10} md={8} lg={6}>
              <h2
                className={classes.cardTitle}
                style={{ fontSize: '1.8rem', color: '#333' }}
              >
                Personal Information
              </h2>
              <form className={classes.form} onSubmit={this.handleSubmit}>
                <center>Email: {this.props.email || 'loading...'}</center>
                <Card
                  style={{
                    paddingLeft: '20px',
                    marginBottom: '0',
                    marginTop: '20px',
                  }}
                >
                  <CustomInput
                    labelText="First Name"
                    id="firstName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: 'text',
                      disableUnderline: true,
                      onChange: this.handleChange,
                    }}
                  />
                </Card>
                <Card
                  style={{
                    paddingLeft: '20px',
                    marginBottom: '0',
                    marginTop: '20px',
                  }}
                >
                  <CustomInput
                    labelText="Last Name"
                    id="lastName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: 'text',
                      disableUnderline: true,
                      onChange: this.handleChange,
                    }}
                  />
                </Card>
                <Card
                  style={{
                    paddingLeft: '20px',
                    paddingTop: '10px',
                    marginBottom: '0',
                    marginTop: '20px',
                  }}
                >
                  Date of Birth
                  <br />
                  <DatePicker
                    onChange={this.handleDateChange}
                    value={this.state.dob ? this.state.dob : ''}
                  />
                </Card>
                <Card
                  style={{
                    paddingLeft: '20px',
                    marginBottom: '0',
                    marginTop: '20px',
                  }}
                >
                  <CustomInput
                    labelText="Phone Number"
                    id="phone"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      maxLength: '16',
                      type: 'text',
                      disableUnderline: true,
                      onChange: this.handleChange,
                    }}
                  />
                </Card>

                <FormControl
                  style={{ marginTop: '20px' }}
                  fullWidth
                  className={classes.selectFormControl}
                >
                  <InputLabel
                    shrink={true}
                    htmlFor="userType"
                    className={classes.selectLabel}
                  >
                    User Type:
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    classes={{
                      select: classes.select,
                    }}
                    required
                    value={this.state.userType}
                    onChange={this.handleSelectChange}
                    inputProps={{
                      id: 'userType',
                      name: 'userType',
                    }}
                  >
                    {config.userTypes.map((item) => (
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                        }}
                        value={item}
                        key={item}
                      >
                        {capitalize(item)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      tabIndex={-1}
                      onClick={this.isAdvertiser}
                      checked={this.state.advertiser}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      color="primary"
                      classes={{
                        checked: classes.checked,
                        root: classes.checkRoot,
                      }}
                    />
                  }
                  classes={{ label: classes.bodyText }}
                  label="Advertiser?"
                />
                {this.state.userType ? (
                  <div className={classes.center}>
                    <Button
                      type="submit"
                      //onClick={() => this.continueForm()}
                      //color="primary"
                      style={{ backgroundColor: '#0EB2D8', fontSize: '1rem' }}
                    >
                      <b>Continue</b> <ArrowRightAltIcon />
                    </Button>
                  </div>
                ) : (
                  'Please fill out form.'
                )}
                <Dialog
                  classes={{
                    root: classes.modalRoot,
                    paper: classes.modal + ' ' + classes.modalLarge,
                  }}
                  open={this.state.openAssignLawyer}
                  TransitionComponent={Transition}
                  keepMounted
                  onClose={() => this.handleClose('openAssignLawyer')}
                  aria-labelledby="shipment-modal-slide-title"
                  aria-describedby="shipment-modal-slide-description"
                >
                  <DialogTitle
                    id="shipment-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                  >
                    <h2 className={classes.modalTitle}>
                      <b>Legal Disclaimer</b>
                    </h2>
                  </DialogTitle>
                  <DialogContent
                    style={{ backgroundColor: '#f7f3f0' }}
                    id="shipment-modal-slide-description"
                    className={classes.modalBody}
                  >
                    {' '}
                    <br />
                    <GridContainer>
                      <GridItem xs={6}>
                        <Button
                          className={classes.ltrButtonWhite}
                          style={{
                            backgroundColor: '#170f56',
                            marginTop: '-68px',
                            color: 'white',
                            width: '100%',
                          }}
                          key="close"
                          aria-label="Close"
                          onClick={() => this.handleClose('openAssignLawyer')}
                        >
                          <b>PREVIOUS</b>
                        </Button>
                      </GridItem>
                      <GridItem xs={6}>
                        <Button
                          className={classes.ltrButtonWhite}
                          style={{
                            backgroundColor: '#170f56',
                            marginTop: '-68px',
                            color: 'white',
                            width: '100%',
                          }}
                          key="close"
                          aria-label="Close"
                          type="submit"
                        >
                          <b>CONTINUE</b>
                        </Button>
                      </GridItem>
                    </GridContainer>
                    {/* FORM */}
                  </DialogContent>
                </Dialog>
              </form>
            </GridItem>
          </GridContainer>
        )}
        {this.state.continueForm &&
          !this.state.continueForm2 && (
            <GridContainer>
              <GridItem xs={12}>
                {this.state.userType == 'client' ? (
                  <CreateCaseForm />
                ) : (
                  <p>Lawyer</p>
                )}
              </GridItem>
            </GridContainer>
          )}
      </div>
    );
  }
}

SetupPage.propTypes = {
  uid: PropTypes.string,
  email: PropTypes.string,
  push: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  startUpdateUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { user } = state.auth || {};
  const { uid, email } = user || {};
  return { uid, email };
};

export default compose(
  connect(
    mapStateToProps,
    { startUpdateUser, push }
  ),
  withStyles(Style)
)(SetupPage);
